import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomLayerButton = styled(Button)(({theme, activebutton}) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: activebutton === 'true' ? theme.buttonSettingIcon.backgroundActiveColor : theme.buttonSettingIcon.backgroundColor,
  color: activebutton === 'true' ? theme.buttonSettingIcon.contrastTextActive :  theme.buttonSettingIcon.contrastText,
  textTransform: 'none',
  paddingX: '1em',
  paddingY: '0.4em',
  borderRadius: '100vmax',
  '&:hover': {
    backgroundColor: theme.palette.common.hover,
    color: theme.palette.common.texthover
  }
}));

export const CustomSettingButton = styled(Button)(({theme}) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.buttonSettingIcon.backgroundColor,
  color: theme.buttonSettingIcon.contrastTextSettings,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.texthover
  }
}));

export const CustomButtonSide = styled(Button)(({color, background}) => ({
  color: `${color}`,
  fontSize: '0.6em',
  fontWeight: '700',
  height: '3.5em',
  width: '3em',
  borderRadius: '0.5em',
  backgroundColor: background ? `${background}` : '#FFFFFF',
  '&:hover': { 
    bgcolor: '#000000' 
  }
}));

export const CustomButtonItinFeature =  styled(Button)(({theme}) => ({
  backgroundColor: theme.buttonItinFeature.background,
  color: theme.buttonItinFeature.color,
  fontSize: '.8em',
  height: '3.8em',
  width: '100%',
  paddingLeft: '2.2em',
  paddingRight: '2.2em',
  borderRadius: '100vmax',
  alignSelf: 'center',
  maxWidth: '88%',
  '&:hover': {
    backgroundColor: theme.buttonItinFeature.backgroundHover,
    color: theme.buttonItinFeature.colorHover
  }
}));

export const CustomButtonWithIcon = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#000000',
  alignItems: 'center',
  borderRadius: '100vmax',
  display: 'inline-flex',
  justifyContent: 'center',
  lineHeight: 1,
  fontSize: '0.85em',
  paddingBlock: '1.5rem',
  paddingInline: '4rem',
  '&:hover': {
    backgroundColor: theme.buttonItinFeature.backgroundHover,
    color: theme.buttonItinFeature.colorHover,
    textDecoration: 'underline'
  }
}));

export const CustomButtonLegends = styled(Button)(() => ({
  color: '#FFFFFF',
  paddingInline: '1rem',
  alignItems: 'flex-start',
  justifyContent: 'center',
  textTransform: 'initial',
  flexWrap: 'wrap',
  '&:hover': {
    textDecoration: 'underline'
  }
}));